import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Send, Eye, Fingerprint } from 'lucide-react';
const features = [{
  icon: Shield,
  title: 'Aegis Vault',
  description: 'Military-grade AES-256 encrypted storage for every credential, secret, and sensitive document. Zero-knowledge architecture means even we cannot see your data.'
}, {
  icon: Send,
  title: 'Phantom Relay',
  description: 'Share credentials securely with time-limited, self-destructing links. No plaintext ever touches the wire.'
}, {
  icon: Eye,
  title: 'Cerberus Watch',
  description: 'Continuous dark web monitoring alerts you the instant your data surfaces in a breach. React before attackers exploit it.'
}, {
  icon: Fingerprint,
  title: 'Obsidian Shield',
  description: 'Hardware-backed biometric authentication and adaptive MFA that stops unauthorized access cold — even if passwords leak.'
}];
export function FeaturesSection() {
  return <section id="solutions" className="py-24 bg-[#0a0a0f] relative overflow-hidden" data-id="element-10">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10 pointer-events-none" data-id="element-11" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-14">
            IRONKEEP <span className="text-[#00ff88]" data-id="element-15">ARSENAL</span>
          </h2>
          <p className="text-[#a0a0b0] max-w-2xl mx-auto font-mono text-lg" data-id="element-16">
            Four pillars of impenetrable defense
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-17">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -50 : 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#111118] border-l-4 border-[#00ff88] p-8 rounded-r-lg hover:bg-[#1a1a24] transition-all group" data-id="element-18">
              <div className="flex items-start gap-6" data-id="element-19">
                <div className="p-4 bg-[#00ff88]/10 rounded-lg group-hover:shadow-[0_0_15px_rgba(0,255,136,0.3)] transition-all" data-id="element-20">
                  <feature.icon className="w-8 h-8 text-[#00ff88]" data-id="element-21" />
                </div>
                <div data-id="element-22">
                  <h3 className="text-2xl font-bold text-white mb-3 font-mono group-hover:text-[#00ff88] transition-colors" data-id="element-23">
                    {feature.title}
                  </h3>
                  <p className="text-[#a0a0b0] leading-relaxed" data-id="element-24">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}